
import Hero from '../../components/sections/Hero';
import Services from '../../components/sections/Services';
import TechStack from '../../components/sections/TechStack';
import About from '../../components/sections/About';
import Contact from '../../components/sections/Contact';
import Navbar from '../../components/layout/Navbar';
import Footer from '../../components/layout/Footer';
import { SEO, generateOrganizationSchema, generateWebsiteSchema } from '../../utils/seo';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://balamtech.com';
  
  const combinedSchema = {
    "@context": "https://schema.org",
    "@graph": [
      generateOrganizationSchema(),
      generateWebsiteSchema()
    ]
  };

  return (
    <>
      <SEO
        title="Balam Technology - Custom Software Development"
        description="We build the future with custom software. Innovation, trust, modern tech. Specializing in React, AWS, web applications, APIs, and landing pages."
        keywords="custom software development, web development, React, AWS, API development, landing pages, web applications, modern tech stack"
        url={siteUrl}
        type="website"
        schema={combinedSchema}
      />
      <div className="min-h-screen bg-white">
        <Navbar />
        <Hero />
        <Services />
        <TechStack />
        <About />
        <Contact />
        <Footer />
      </div>
    </>
  );
}
